import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import { Section } from 'components/features/components/marketing-tile-group/styled';
import { SecondaryLink } from 'components/link';
import Picture from 'components/picture';

import { GameplayButton } from '../sections/gameplay/components';
import { GameplayBackgroundGradient } from '../sections/gameplay/components/gameplay-background/gameplay-background';
import { TypographyContainer, TypographyContainerProps } from '../typography/sanity-block-content';

export const BannerWrapper = styled(Section)``;

export const Background = styled(GameplayBackgroundGradient)`
  border-radius: ${Styles.borderRadius};
`;

/* override some styles from SanityBlockContent specific to this banner*/
export const HomepageBannerTypography = styled(TypographyContainer)<TypographyContainerProps>`
  h2 {
    letter-spacing: -1.9px;
    font-size: 2.75rem;
    font-weight: 900;
    font-style: normal;
  }
  h3 {
    letter-spacing: -1.9px;
    font-size: 2.1rem;
    font-weight: 900;
    font-style: normal;
  }
  ${Styles.desktop`
    h2 {
      font-size: 3.7rem;
    }
    h3 {
      font-size: 3.7rem;
    }
    padding-bottom: 1.5rem;
  `}
`;

export const TopContent = styled(ClickableContainer)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  flex: 1;
`;

export const ClickWrap = styled(ClickableContainer)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  flex: 1;
`;

export const MobileLeft = styled.div`
  display: flex;
  flex: 4;
  padding-left: 1rem;
  padding-top: 2rem;
`;

export const MobileRight = styled.div`
  display: flex;
  flex: 6;
  max-height: 300px;
`;

export const DesktopLeft = styled.div`
  display: flex;
  flex: 6;
  padding-top: 2rem;
`;

export const DesktopRight = styled.div`
  display: flex;
  flex: 3;
  max-height: 300px;
`;

export const Image = styled(Picture)`
  display: flex;
`;

export const MobileButtonContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const DesktopButtonContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
`;

export const ButtonWrapper = styled.div`
  display: block;
  padding: 0.4rem 0;
  ${Styles.desktop`
    padding: 0;
  `}
`;

export const GameplayButtonWrapper = styled(GameplayButton)`
  padding: 0.1rem;
  div > div {
    padding: 0 0.4rem;
  }
`;

export const GameplayButtonText = styled.div`
  font-size: 0.8rem;
`;

export const RulesText = styled.p`
  color: ${Styles.color.white};
  font-size: 0.75em;
  line-height: 1;
  margin: 0;
  padding: 0 1rem 1rem;
`;

export const StyledLink = styled(SecondaryLink)`
  font-size: 0.75em;
  font-weight: ${Styles.fontWeight.heavy};
  margin-top: 0.5rem;
`;

export const LinkText = styled.span`
  text-decoration: underline;
`;

export const LinkTriangle = styled.span`
  font-size: 0.75em;
`;
